import { useNavigate } from 'react-router-dom';
import { EmptyState, Icon } from '../../../components';
import { AppRoutes } from '../../../constants';
import { ReviewFilters, ReviewTab as ReviewTabType } from '../../../types';
import { isFiltersDirty } from '../../../utils';

const NO_CALLS_FOUND_FOR_FILTERS_DESCRIPTION = 'No calls found for the selected filters';

interface ReviewPageEmptyStateProps {
  filters: ReviewFilters;
  activeTab: ReviewTabType;
  setIsImportRealCallsModalOpen: (isOpen: boolean) => void;
}

const ReviewPageEmptyState = ({ filters, activeTab, setIsImportRealCallsModalOpen }: ReviewPageEmptyStateProps) => {
  const navigate = useNavigate();

  const filtersApplied = isFiltersDirty(filters);
  const isSimulationsTab = activeTab === ReviewTabType.SIMULATIONS;

  return (
    <>
      {isSimulationsTab && (
        <EmptyState
          ctaButtonProps={
            filtersApplied
              ? undefined
              : {
                  text: 'Call now',
                  onClick: () => navigate(AppRoutes.SIMULATIONS),
                }
          }
          icon={Icon.HISTORY}
          description={filtersApplied ? NO_CALLS_FOUND_FOR_FILTERS_DESCRIPTION : 'Make calls to start seeing them here'}
        />
      )}
      {!isSimulationsTab && (
        <EmptyState
          ctaButtonProps={
            filtersApplied
              ? undefined
              : {
                  text: 'Import real calls',
                  onClick: () => setIsImportRealCallsModalOpen(true),
                }
          }
          title={filtersApplied ? undefined : 'No real calls yet'}
          description={
            filtersApplied ? (
              NO_CALLS_FOUND_FOR_FILTERS_DESCRIPTION
            ) : (
              <>
                Import sales calls to review conversations,
                <br />
                track performance, and get coaching
              </>
            )
          }
        />
      )}
    </>
  );
};

export default ReviewPageEmptyState;
